import * as React from "react";
import PropTypes from "prop-types";
import includes from "lodash/includes";
import Checkbox from "../../Checkbox";
import RichLabel from "../../RichLabel";
import ItemList from "../../ItemList";
import Theme from "../../Theme";
import prefixStyles from "../../utils/prefixStyles";

export default class MultiSelectField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        icon: PropTypes.node,
      })
    ),
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    options: [],
    value: [],
  };

  state = {
    currentValue: this.props.value,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ currentValue: nextProps.value });
  }

  _handleChange = (toggledValue, checked) => {
    const { currentValue } = this.state;
    let newValue;
    if (checked) {
      newValue = [...currentValue, toggledValue];
    } else {
      newValue = currentValue.filter((value) => value !== toggledValue);
    }
    this.setState({ currentValue: newValue }, () => {
      this.props.onChange(newValue);
    });
  };

  render() {
    const { label, options, name, disabled } = this.props;
    const { currentValue } = this.state;

    const styles = prefixStyles({
      wrapper: {
        marginTop: "0.9em",
        marginBottom: "0.9em",
      },
      heading: {
        paddingLeft: Theme.Padding.CONTENT,
        paddingRight: Theme.Padding.CONTENT,
        display: "flex",
        justifyContent: "space-between",
      },
    });

    return (
      <div data-component-name="MultiSelectField" style={styles.wrapper}>
        <div data-component-section="heading" style={styles.heading}>
          <span data-component-section="label">{label}</span>
          <Checkbox
            data-component-section="group-checkbox"
            indeterminate={
              currentValue.length > 0 && currentValue.length < options.length
            }
            checked={currentValue.length > 0}
            disabled={disabled}
            onTap={
              disabled
                ? null
                : () => {
                    let newValue;
                    if (currentValue.length === 0) {
                      newValue = options.map((option) => option.value);
                    } else {
                      newValue = [];
                    }

                    this.setState({ currentValue: newValue }, () => {
                      this.props.onChange(newValue);
                    });
                  }
            }
          />
        </div>
        <ItemList
          id={name}
          showDividers
          dividerProps={{
            overflow: false,
          }}
          items={options.map((option) => {
            const id = option.id || `${name}-${option.value}`;
            const checked = includes(currentValue, option.value);

            return {
              id,
              onTap: disabled
                ? null
                : () => {
                    this._handleChange(option.value, !checked);
                  },
              label: (
                <RichLabel
                  icon={option.icon}
                  label={option.label}
                  style={{ marginLeft: Theme.Padding.CONTENT }}
                />
              ),
              children: (
                <Checkbox
                  checked={checked}
                  disabled={disabled}
                  style={{ marginRight: Theme.Padding.CONTENT }}
                />
              ),
              updateKey: `${id},checked=${checked}`,
              "aria-pressed": String(Boolean(checked)),
            };
          })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/MultiSelectField.jsx